import styled from "styled-components";

export const Table = styled.table`
  margin: 2rem 0;
  width: 47.5rem;
  border-radius: 0.5rem;
  outline: #ffffff solid 1px;
  border-collapse: collapse;
  text-align: center;
`;
export const Thead = styled.thead`
  font-size: 1rem;
  color: #5fdd63;
  border-bottom: 1px solid #ffffff;
`;
export const Tbody = styled.tbody`
  font-family: Arial, sans-serif;
  font-size: 1rem;
  color: #c2e9e0;
`;
export const TableCell = styled.td`
  border-bottom: 1px solid #ffffff;
  padding: 0.5rem;
`;
export const TableHeader = styled.th`
  border-bottom: 1px solid #ffffff;
  padding: 0.5rem;
`;
